module.exports = __webpack_public_path__ + "static/media/edit.3f60d30e.svg";